import { ref } from 'vue';
import Cookies from 'js-cookie';
import { usePageContext } from '@/src/composables/usePageContext';

export function useStorage() {
  const getStorageValue = (name: string, pageContext = usePageContext()): string | null => {
    if (!import.meta.env.SSR) {
      const localStorageValue = window.localStorage?.getItem(name);
      const cookieStorageValue = Cookies.get(name);
      if (localStorageValue && localStorageValue !== 'null') {
        return localStorageValue;
      }
      if (cookieStorageValue && cookieStorageValue !== 'null') {
        return cookieStorageValue;
      }
    } else {
      const cookies = pageContext?.headers?.cookie?.split('; ').filter((el: string) => el.includes(name));
      return cookies?.length ? cookies[0].split('=')[1] : null;
    }
    return null;
  };

  const setStorageValue = (name: string, value: string, lifetime = 365): void => {
    if (!import.meta.env.SSR) {
      if (window.localStorage) {
        window.localStorage.setItem(name, value);
      } else {
        Cookies.set(name, value, { sameSite: 'strict', expires: lifetime });
      }
    }
  };

  const setCookie = (name: string, value: string, lifetime = 365): void => {
    if (!import.meta.env.SSR) {
      Cookies.set(name, value, { sameSite: 'strict', expires: lifetime });
    }
  };

  const removeStorageValue = (name: string): void => {
    if (!import.meta.env.SSR) {
      if (window.localStorage) {
        window.localStorage.removeItem(name);
      }
      Cookies.remove(name);
    }
  };

  return {
    getStorageValue,
    setStorageValue,
    setCookie,
    removeStorageValue,
  };
}
